import Subject from "./event-observer";
import GlobalContext from "@csgp-mfe-utils/global-context";
const COSTAR_EVENT_BUS = "COSTAR_MFE_PUBSUB_SUBJECTS";
const _subjects = (function () {
    if (!GlobalContext.isExistingContextId(COSTAR_EVENT_BUS)) {
        GlobalContext.registerGlobalContext(COSTAR_EVENT_BUS, {});
    }
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return GlobalContext.useContext(COSTAR_EVENT_BUS);
})();
/**
 * Retrieves or creates a {@link Subject} of the given name
 *
 * @api
 *
 * @param name the name of the subject you want to observe
 * @param options the options used to initialize the subject **if it does not already exist**;
 * these will be **ignored** if the subject already exists
 *
 * @returns a {@link Subject} of the given name that can be observed
 */
const subject = (name) => { var _a; return ((_a = _subjects[name]) !== null && _a !== void 0 ? _a : (_subjects[name] = new Subject(name))); };
// TODO(don): Phase out usage of named {@link subject} export
export { subject, Subject };
export default subject;
//# sourceMappingURL=index.js.map